import React from 'react'
import Lottie from 'lottie-react'
import { loadingBasket } from '../../../assets'
import { Box } from '@mui/material'

const BasketLoading = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Lottie
        style={{
          width: '250px', // mudar tamanho p desktop se necessario
          height: '250px', // mudar tamanho p desktop se necessario
          opacity: 0.8,
        }}
        animationData={loadingBasket}
      />
    </Box>
  )
}

export default BasketLoading
